import React, { Component, useState, useEffect } from "react";
import PropTypes from "prop-types";
import LoadingIndicator from "./components/loading-indicator";
import VerticalCenter from "./components/vertical-center";
import { pathInResponsiveViews } from "./route-utils";

function ProgressBar({ percent, autoIncrement, intervalTime, spinner }) {
  const [value, setValue] = useState(percent || 0);
  useEffect(() => {
    setValue(percent || 0);
  }, [percent]);
  useEffect(() => {
    if (!autoIncrement) return;
    const id = setInterval(() => {
      setValue(v => (v >= 99 ? v : v + 1));
    }, intervalTime || 300);
    return () => clearInterval(id);
  }, [autoIncrement, intervalTime]);
  return (
    <div style={{ width: '100%', height: '3px', background: 'rgba(255,255,255,0.2)' }}>
      <div style={{ width: value + '%', height: '100%', background: '#fff', transition: 'width 0.2s ease' }} />
    </div>
  );
}

class SplashScreen extends Component {
  render() {
    const { isEmbed, style, loadState } = this.props;
    return (
      <VerticalCenter style={style || { width: "100%", height: "100%" }}>
        <center>
          <LoadingIndicator isEmbed={isEmbed} />
          {!pathInResponsiveViews() && (
            <div style={{ width: '200px', marginTop: '76px' }}>
              <ProgressBar
                percent={loadState}
                autoIncrement={true}
                intervalTime={300}
                spinner={false}
              />
            </div>
          )}
        </center>
      </VerticalCenter>
    );
  }
}

SplashScreen.defaultProps = {
  loadState: 0,
};

SplashScreen.propTypes = {
  loadState: PropTypes.number.isRequired,
};

export default SplashScreen;
